module.exports = __webpack_public_path__ + "static/media/IMG_3494_sm.73328cad.jpg";